import { render, staticRenderFns } from "./NotificationSettingsTab.vue?vue&type=template&id=70943002&scoped=true"
import script from "./NotificationSettingsTab.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70943002",
  null
  
)

export default component.exports